// reducers/core/pages.js

export function pageHasErrored(state = false, action) {
  switch (action.type) {
    case 'PAGE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function pageIsLoading(state = true, action) {
  switch (action.type) {
    case 'PAGE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function page(state = [], action) {
  switch(action.type) {
    case 'PAGE_FETCH_DATA_SUCCESS':
      return action.response;
    default:
      return state;
  }
}